<template>
  <v-list-tile-action :class="{'grow-2': $vuetify.breakpoint.xsOnly}">
    <v-layout
      row
      align-center
    >
      <v-spacer />
      <v-layout
        column
        align-end
        class="mr-2"
        :class="{
          'msr--text': highlighted,
          'grey--text text--darken-3': !highlighted,
        }"
        :style="{
          'font-size':
            $vuetify.breakpoint.xsOnly && coverSize === 'mini' ? '9px' : '13px',
        }"
      >
        <div
          v-if="showLabel"
          :class="{
            'grey--text text--darken-3': !highlightLabel,
            'msr--text': highlightLabel,
          }"
        >
          {{ $t(label) }}:
        </div>
        <div>{{ channel.name }}</div>
      </v-layout>
      <img
        v-if="channel && channel.cover"
        :src="channel.cover"
        :class="`${coverSize}-cover-image`"
        :width="coverSize === 'mini' ? '36px' : '48px'"
        :height="coverSize === 'mini' ? '36px' : '48px'"
      >
      <div
        v-else
        :class="`${coverSize}-cover-image`"
      >
        <v-icon medium>
          music_note
        </v-icon>
      </div>
    </v-layout>
  </v-list-tile-action>
</template>

<script>
export default {
  name: 'MiniRadioChannelTileAction',
  props: {
    channel: {
      type: Object,
      required: true,
    },
    highlighted: {
      type: Boolean,
      default: false,
    },
    coverSize: {
      type: String,
      default: 'mini',
      validator: function (v) {
        return v === 'mini' || v === 'small';
      },
    },
    label: {
      type: String,
      default: 'currentChannelBeingReplaced',
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    highlightLabel: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.small-cover-image {
  min-width: 48px;
  min-height: 48px;
  width: 48px;
  height: 48px;
}

.mini-cover-image {
  min-width: 36px;
  min-height: 36px;
  width: 36px;
  height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniRadioChannelTileAction.vue